module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    class: _vm.bgClass,
    attrs: {
      "gutter": 12,
      "justify": "center"
    }
  }, [(_vm.isTowerCo() && (_vm.totalRequests < _vm.stats.actions || _vm.stats.assets > 0)) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": _vm.media.align
    }
  }, [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "header": "Assets & Services",
      "shadow": "hover"
    }
  }, [(_vm.totalRequests < _vm.stats.actions) ? _c('dash-text', {
    attrs: {
      "caption": "Action",
      "icon": "fa fa-asterisk",
      "value": _vm.stats.actions - _vm.totalRequests,
      "color": "darkgrey",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.capSize
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stats.assets > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Asset",
      "icon": "fa fa-cogs",
      "value": _vm.stats.assets,
      "color": "slateblue",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.capSize
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stats.Progress > 0) ? _c('dash-text', {
    attrs: {
      "caption": _vm.permitLabel,
      "no-plural": "",
      "value": _vm.stats.Progress,
      "icon": "fa fa-file-alt",
      "color": "slategrey",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.capSize
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stats.services > 0) ? _c('table', {
    staticClass: "el-table semi-transparent"
  }, [(_vm.stats.service5G) ? _c('tr', {
    staticClass: "semi-transparent"
  }, [_c('td', [_vm._v("5G:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.stats.service5G))])])]) : _vm._e(), _vm._v(" "), (_vm.stats.service4G) ? _c('tr', {
    staticClass: "semi-transparent"
  }, [_c('td', [_vm._v("4G:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.stats.service4G))])])]) : _vm._e(), _vm._v(" "), (_vm.stats.service3G) ? _c('tr', {
    staticClass: "semi-transparent"
  }, [_c('td', [_vm._v("3G:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.stats.service3G))])])]) : _vm._e(), _vm._v(" "), (_vm.stats.service2G) ? _c('tr', {
    staticClass: "semi-transparent"
  }, [_c('td', [_vm._v("2G:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.stats.service2G))])])]) : _vm._e(), _vm._v(" "), (_vm.stats.serviceCMDA) ? _c('tr', {
    staticClass: "semi-transparent"
  }, [_c('td', [_vm._v("CMDA:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.stats.serviceCMDA))])])]) : _vm._e(), _vm._v(" "), (_vm.stats.serviceHPSA) ? _c('tr', {
    staticClass: "semi-transparent"
  }, [_c('td', [_vm._v("HPSA:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.stats.serviceHPSA))])])]) : _vm._e(), _vm._v(" "), (_vm.stats.serviceFDD) ? _c('tr', {
    staticClass: "semi-transparent"
  }, [_c('td', [_vm._v("FDD:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.stats.serviceFDD))])])]) : _vm._e(), _vm._v(" "), (_vm.stats.serviceLTE) ? _c('tr', {
    staticClass: "semi-transparent"
  }, [_c('td', [_vm._v("LTE:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.stats.serviceLTE))])])]) : _vm._e(), _vm._v(" "), (_vm.stats.serviceTDD) ? _c('tr', {
    staticClass: "semi-transparent"
  }, [_c('td', [_vm._v("TDD:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.stats.serviceTDD))])])]) : _vm._e(), _vm._v(" "), (_vm.stats.serviceUMTS) ? _c('tr', {
    staticClass: "semi-transparent"
  }, [_c('td', [_vm._v("UMTS:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.stats.serviceUMTS))])])]) : _vm._e()]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && (_vm.stats.terminatedTelcos > 0 || _vm.stats.sharers > 0)) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": _vm.media.align
    }
  }, [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "header": "Telcos",
      "shadow": "hover"
    }
  }, [(_vm.stats.sharers > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Telco",
      "icon": "fa fa-users",
      "value": _vm.stats.sharers,
      "color": "darkgrey",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.capSize
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stats.terminatedSharers > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Terminated",
      "icon": "fa fa-user-slash",
      "value": _vm.stats.terminatedSharers,
      "color": "indianred",
      "no-plural": "",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.capSize
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && _vm.showRequests && (_vm.stats.rts > 0 || _vm.stats.rtu > 0 || _vm.stats.rtb > 0)) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": _vm.media.align
    }
  }, [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "header": "Requests",
      "shadow": "hover"
    }
  }, [(_vm.stats.rts > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Share",
      "icon": "fa fa-share-alt",
      "value": _vm.stats.rts,
      "color": "seagreen",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.capSize
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stats.rtu > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Upgrade",
      "icon": "fa fa-tools",
      "value": _vm.stats.rtu,
      "color": "navy",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.capSize
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stats.rtb > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Backhaul",
      "icon": "fa fa-wifi",
      "value": _vm.stats.rtb,
      "color": "darkgrey",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.capSize
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isTowerCo() && _vm.stats.assets > 0) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": _vm.media.align
    }
  }, [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "header": "Assets",
      "shadow": "hover"
    }
  }, [(_vm.stats.assets > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Asset",
      "icon": "fa fa-cogs",
      "value": _vm.stats.assets,
      "color": "slateblue",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.capSize
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.stats.backhaul > 0) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": _vm.media.align
    }
  }, [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "header": "Backaul",
      "shadow": "hover"
    }
  }, [(_vm.stats.backhaul > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Provider",
      "icon": "fa fa-wifi",
      "value": _vm.stats.backhaul,
      "color": "navy",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.capSize
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && _vm.stats.tickets > 0) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": _vm.media.align
    }
  }, [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "header": "Tickets",
      "shadow": "hover"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Total",
      "icon": "fa fa-headset",
      "value": _vm.stats.tickets,
      "color": "darkorange",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.capSize
    }
  }), _vm._v(" "), ((_vm.stats.ticketCritical > 0 || _vm.stats.ticketUrgent > 0)) ? _c('dash-text', {
    attrs: {
      "caption": "Priority: Critical | Urgent",
      "no-plural": "",
      "icon": "fa fa-exclamation-circle",
      "value": Number(_vm.stats.ticketCritical) + Number(_vm.stats.ticketUrgent),
      "color": "indianred",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.ticketCapSize
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stats.ticketOverdue > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Priority: Overdue",
      "no-plural": "",
      "value": _vm.stats.ticketOverdue,
      "icon": "fa fa-hourglass-end",
      "color": "orange",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.ticketCapSize
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stats.ticketOpen > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Status:Open",
      "no-plural": "",
      "value": _vm.stats.ticketOpen,
      "icon": "fa fa-folder-open",
      "color": "slategrey",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.ticketCapSize
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stats.ticketWIP > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Status: In Progress",
      "no-plural": "",
      "value": _vm.stats.ticketWIP,
      "icon": "fa fa-tasks",
      "color": "navy",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.ticketCapSize
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stats.ticketPending > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Status: Pending",
      "no-plural": "",
      "value": _vm.stats.ticketPending,
      "icon": "fa fa-clock",
      "color": "lightgrey",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.ticketCapSize
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stats.ticketClosed > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Status: Closed",
      "no-plural": "",
      "value": _vm.stats.ticketClosed,
      "icon": "fa fa-folder",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.ticketCapSize
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && _vm.stats.landlords > 0) ? _c('el-col', {
    attrs: {
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg,
      "align": _vm.media.align
    }
  }, [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "header": "Landlord",
      "shadow": "hover"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Landlord",
      "icon": "fa fa-home",
      "value": _vm.stats.landlords,
      "color": "slategrey",
      "align": _vm.align,
      "size": _vm.size,
      "caption-size": _vm.capSize
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63cb051c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/SiteStats.vue
// module id = 1607
// module chunks = 0